import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "data/backOfficeConnector";
import type EventBus from "services/eventBus";
import type { IPagination } from "data/types";
import { serializeFilters } from "utils/filters";
import CardGatewayPaymentDetailResponse from "entities/cardGatewayPaymentDetailResponse";
import type SearchPayGatePaymentsRequest from "entities/searchPayGatePaymentsRequest";
import CardGatewayPayment from "entities/cardGatewayPaymentResponse";
import type SearchTransferPaymentsRequest from "entities/searchTransferPaymentsRequest";
import TransferPaymentResponse from "entities/transferPaymentResponse";
import TransferPaymentDetailResponse from "entities/transferPaymentDetailResponse";

export default class PaymentsRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAllCardGatewayPayments(pagination: IPagination, filters: SearchPayGatePaymentsRequest, abortSignal: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("pay_gate_payment_search")
          .postPagedEntities<CardGatewayPayment>(
            serializeFilters({ ...filters, ...pagination }, false),
            CardGatewayPayment,
            abortSignal,
            pagination
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  getAllBankTransferPayments(pagination: IPagination, filters: SearchTransferPaymentsRequest, abortSignal: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("transfer_payment_search")
          .postPagedEntities<TransferPaymentResponse>(
            serializeFilters({ ...filters, ...pagination }, false),
            TransferPaymentResponse,
            abortSignal
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }
  async getCardGatewayPaymentDetail(paymentId: string) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("pay_gate_payments")
          .one(paymentId)
          .getEntity<CardGatewayPaymentDetailResponse>(CardGatewayPaymentDetailResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  async getBankTransferPaymentDetail(paymentId: string) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("transfer_payments")
          .one(paymentId)
          .getEntity<TransferPaymentDetailResponse>(TransferPaymentDetailResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }
}
